export var MONEY_TRANSFER_ONLY = ['in', 'hk', 'ae', 'zh-hk'];
export var SUPPORTED_CARD_LOCALES = ['ad', 'at', 'au', 'ax', 'be', 'bg', 'bl', 'br', 'ca', 'ch', 'cw', 'cy', 'cz', 'de', 'dk', 'ee', 'es', 'fi', 'fk', 'fo', 'fr', 'gb', 'gf', 'gg', 'gi', 'gl', 'gp', 'gr', 'gs', 'hr', 'hu', 'ie', 'im', 'is', 'it', 'je', 'jp', 'ky', 'li', 'lt', 'lu', 'lv', 'mc', 'mf', 'mq', 'ms', 'mt', 'my', 'nc', 'nl', 'no', 'nz', 'pf', 'pl', 'pm', 'pt', 're', 'ro', 'se', 'sg', 'sh', 'si', 'sk', 'sm', 'sx', 'tf', 'ua', 'us', 'va', 'vg', 'wf', 'yt'];
export var SUPPORTED_CARD_WAITLIST_LOCALES = [];
export var SUPPORTED_BUSINESS_LOCALES = [
// without business card locales
'br', 'ca', 'cz', 'gr', 'hk', 'jp', 'mx', 'se', 'sg', 'us', 'zh-hk'];
export var SUPPORTED_BUSINESS_BORDERLESS_LOCALES = ['au', 'bg', 'ca', 'ch', 'cz', 'de', 'es', 'fr', 'gb', 'hu', 'ie', 'it', 'mx', 'nl', 'nz', 'pl', 'pt', 'ro', 'se', 'sg', 'us'];
export var SUPPORTED_BUSINESS_CARD_LOCALES = ['gb', 'us', 'it', 'ca', 'ro', 'fr', 'nz', 'de', 'au', 'sg', 'ie'];
export default function shouldShowItemForLocale(item, locale) {
  if (item.isBorderless) {
    return !SUPPORTED_CARD_LOCALES.includes(locale) && !MONEY_TRANSFER_ONLY.includes(locale);
  }
  if (item.isMoneyTransferOnly) {
    return MONEY_TRANSFER_ONLY.includes(locale);
  }
  if (item.isCard) {
    return SUPPORTED_CARD_LOCALES.indexOf(locale) > -1;
  }
  if (item.isCardWaitlist) {
    return SUPPORTED_CARD_WAITLIST_LOCALES.indexOf(locale) > -1;
  }
  if (item.isBusinessCard) {
    return SUPPORTED_BUSINESS_CARD_LOCALES.indexOf(locale) > -1;
  }
  if (item.isBusiness) {
    return SUPPORTED_BUSINESS_LOCALES.indexOf(locale) > -1;
  }
  if (item.isBusinessBorderless) {
    return SUPPORTED_BUSINESS_BORDERLESS_LOCALES.indexOf(locale) > -1;
  }
  return true;
}